import { PlayingGame } from '../models/playing-game'
import { PlayingGameDto } from '../dtos/playing-game.dto'
import { gamePropsMapper } from './game-props.mapper'

export const playingGameMapper = {
  mapToPlayingGame(playingGameDto: PlayingGameDto): PlayingGame {
    return new PlayingGame({
      ...playingGameDto,
      ...gamePropsMapper.mapToGameProps(playingGameDto),
    })
  },
}
